import { Input, Radio } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface ContentCellProp {
  editParent: string;
  rating: string;
  content: string;
  setValue: Function;
  nameRating: string;
  nameContent: string;
  disabled?: boolean;
  evaluationType?: 'score' | 'pass_fail';
  isPassed?: boolean | null;
}

const ContentCell = (props: ContentCellProp) => {
  const { t } = useTranslation(['performance']);
  const {
    rating,
    content,
    setValue,
    nameRating,
    nameContent,
    disabled = false,
    editParent,
    evaluationType,
    isPassed,
  } = props;

  const [inputValue, setInputValue] = useState(String(rating));

  useEffect(() => {
    console.log('ContentCell render with:', { evaluationType, rating, isPassed });
  }, [evaluationType, rating, isPassed]);

  const handleChange = (e: any) => {
    let value = Number(e.target.value);

    if (!Number.isInteger(value)) {
      value = Math.round(value);
    }

    if (value > 5) {
      value = 5;
    }
    if (value < 0) {
      value = 0;
    }

    setInputValue(String(value));
    setValue(nameRating, String(value));
    setValue(editParent, true);
  };

  // Định nghĩa giá trị cho radio group
  const getRadioValue = () => {
    // Nếu isPassed là null hoặc undefined, return null (N/A)
    if (isPassed === null || isPassed === undefined) {
      return 'null';
    }
    // Nếu isPassed là true, return 1 (Pass)
    if (isPassed === true) {
      return '1';
    }
    // Nếu isPassed là false, return 0 (Fail)
    return '0';
  };

  // Initialize with default value if isPassed is undefined
  const [selectedValue, setSelectedValue] = useState<string>(() => {
    if (isPassed === true) return '1';
    if (isPassed === false) return '0';
    return 'null';
  });

  // Update state when props change
  useEffect(() => {
    if (isPassed === true) {
      setSelectedValue('1');
    } else if (isPassed === false) {
      setSelectedValue('0');
    } else {
      setSelectedValue('null');
    }
  }, [isPassed]);

  // Hàm xử lý khi radio thay đổi
  const handleRadioChange = (e: any) => {
    const radioValue = e.target.value;
    setSelectedValue(radioValue);

    let isPassedValue = null;
    if (radioValue === '1') {
      isPassedValue = true;
    } else if (radioValue === '0') {
      isPassedValue = false;
    }

    // Cập nhật form values
    setValue(nameRating, radioValue === 'null' ? '0' : radioValue);
    setValue(nameRating.replace('point', 'isPassed'), isPassedValue);
    setValue(editParent, true);

    console.log(
      'Updated isPassed:',
      isPassedValue,
      'at path:',
      nameRating.replace('point', 'isPassed'),
    );
  };

  return (
    <div className="evaluation-radio-group">
      {evaluationType === 'pass_fail' ? (
        <div className="pass-fail-container">
          <div className="evaluation-label">{t('performance_review:evaluation_result')}</div>
          <Radio.Group
            disabled={disabled}
            value={selectedValue}
            onChange={handleRadioChange}
            optionType="button"
            buttonStyle="solid"
            className="evaluation-radio-buttons"
          >
            <Radio.Button value="1" className={selectedValue === '1' ? 'selected-pass' : ''}>
              {t('performance_review:pass')}
            </Radio.Button>
            <Radio.Button value="0" className={selectedValue === '0' ? 'selected-fail' : ''}>
              {t('performance_review:fail')}
            </Radio.Button>
            <Radio.Button value="null" className={selectedValue === 'null' ? 'selected-na' : ''}>
              {t('performance_review:not_applicable', 'N/A')}
            </Radio.Button>
          </Radio.Group>
        </div>
      ) : (
        <div>
          <div>{t('performance:rating_point')}</div>
          <Input
            type="number"
            disabled={disabled}
            defaultValue={rating}
            value={inputValue}
            onChange={handleChange}
          />
        </div>
      )}
      <div>{t('performance:accomplishment')}</div>
      <TextArea
        disabled={disabled}
        defaultValue={content}
        onChange={(e) => {
          setValue(nameContent, e.target.value);
          setValue(editParent, true);
        }}
      />
    </div>
  );
};

export default ContentCell;
